import React from 'react';
import { Text } from '@perch-labs/shrike';
import {
  InfoContainer,
  InactiveContainer,
  IconContainer,
} from '../user-rewards.style';

interface Props {
  header: number | string | null;
  subHeader?: string;
  active?: boolean;
}

export const TextSection = ({
  header,
  subHeader = '',
  active = true,
}: Props) => {
  return (
    <div>
      {active ? (
        <InfoContainer>
          <Text
            className="notranslate"
            textStyle="heading900"
            tag="h1"
            color="primaryInverse"
          >
            {header}
          </Text>
          <Text textStyle="heading400" tag="p" color="primaryInverse">
            {subHeader}
          </Text>
        </InfoContainer>
      ) : (
        <InactiveContainer>
          <IconContainer
            color="primaryInverse"
            icon="LightningBolt"
            margin={{ right: '8px' }}
          />
          <Text
            className="notranslate"
            textStyle="paragraph500"
            tag="p"
            color="primaryInverse"
          >
            {header}
          </Text>
        </InactiveContainer>
      )}
    </div>
  );
};
